import { render } from "./OilTest.vue?vue&type=template&id=5da63aed"
import script from "./OilTest.vue?vue&type=script&lang=js"
export * from "./OilTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__